import { useBoolean } from '@insta-club/hooks';
import { Guides, Story } from '@insta-club/models';
import { t } from '@insta-club/translations';
import { GuideDialog, GuidesButton } from '@insta-club/ui';
import { cn } from '@insta-club/utilities';
import { useState } from 'react';
import { CoffeeIcon, VideoCircle } from 'src/libs/components/icons';
import StoryProgram from './program';

interface Props {
    story?: Story;
    programID: number;
    dayNumber: number;
    hasChatBot: boolean;
    canPerformTask: boolean;
    date: string;
}

const StoryTask: React.FC<Props> = ({ story, programID, dayNumber, hasChatBot, date, canPerformTask }) => {
    const sheet = useBoolean();
    const [guide, setGuide] = useState<Guides>();

    const openGuide = (guide: Guides) => {
        sheet.onFalse();
        setTimeout(() => {
            setGuide(guide);
        }, 300);
    };

    const closeGuide = () => {
        setGuide(undefined);
        sheet.onTrue();
    };

    // const disabled = !story;
    // const description = disabled
    //     ? `در این روز ☕ هیچ برنامه ${t('story')} ندارید`
    //     : story?.is_done
    //       ? 'تکمیل شده'
    //       : `شروع از ساعت ${story?.started_at}`;
    // const status = story?.is_done ? 'done' : 'progress';
    const isDone = story?.is_done;
    const isRest = story?.is_rest;

    return (
        <>
            <section
                className={cn('rounded-lg bg-gray-50 p-4', {
                    'space-y-3.5': story
                })}
            >
                <div className='space-y-1'>
                    <div className='flex items-start justify-between'>
                        <h5 className='text-primary-900 flex items-center justify-between space-x-1.5 text-base font-bold'>
                            <div className='flex items-center space-x-1'>
                                <span>برنامه</span>{' '}
                                <span className={isDone ? 'text-success-500' : ''}>{t('story')}</span>
                                {isRest && <CoffeeIcon width={20} className='text-success-500 mr-1 mb-1' />}
                            </div>
                            {/* {!!story?.is_done && <Checkbox checked color='green' readOnly disabled />} */}
                        </h5>
                        {!isRest && (
                            <GuidesButton
                                guideKey='program_story'
                                onClick={openGuide}
                                noModal
                                trigger={
                                    <button
                                        className='text-primary-700 font-500 flex cursor-pointer items-center space-x-1 rounded-full text-sm'
                                        aria-label='ویدیو راهنما'
                                    >
                                        <VideoCircle width={20} />
                                        {/* <span>ویدیو راهنما</span> */}
                                    </button>
                                }
                            />
                        )}
                    </div>
                    <p className='text-right text-sm font-normal text-gray-600'>
                        {!isRest && !story?.is_single && (
                            <>
                                این برنامه پیشنهادی با توجه به بهترین زمان پیک حضور مخاطبین در اینستاگرام است ، شما
                                میتوانید با توجه به شرایط پیجتون زمان ها رو تغییر بدید.
                            </>
                        )}
                        {isRest && <>روز استراحت, امروز استوری جدیدی منتشر نکنید.</>}
                        {!isRest && story?.is_single && <>امروز فقط یک استوری جدید منتشر کن.</>}
                    </p>
                </div>
                {story && !story.is_rest ? (
                    <StoryProgram
                        hasChatBot={hasChatBot}
                        date={date}
                        // onGuide={openGuide}
                        story={story}
                        programID={programID}
                        dayNumber={dayNumber}
                        canPerformTask={canPerformTask}
                    />
                ) : (
                    <></>
                )}

                {/* <CustomCollapse
                    defaultOpen={true}
                    contentBgColor='bg-gray-50'
                    titleClassName='w-full'
                    borderClassName='border-transparent'
                    headerBgColor='bg-gray-100'
                    title={
                        <div className='space-y-2'>
                            <div className='flex items-start justify-between'>
                                <h5 className='text-primary-900 text-base font-bold'>
                                    <span>برنامه</span> <span className='text-success-500'>{t('story')}</span>
                                    {!!story?.is_done && <span>✅</span>}
                                </h5>
                            </div>
                            <p className='text-right text-sm text-gray-500'>{description}</p>
                        </div>
                    }
                >
                    {story ? (
                        <>
                            <div className='mb-2 space-y-1.5'>
                                <p className='text-sm text-gray-500'>
                                    این برنامه پیشنهادی با توجه به بهترین زمان پیک حضور مخاطبین در اینستاگرام است ، شما
                                    میتوانید با توجه به شرایط پیجتون زمان ها رو تغییر بدید.
                                </p>
                                <div className='flex justify-end'>
                                    <GuidesButton
                                        guideKey='program_story'
                                        onClick={openGuide}
                                        noModal
                                        trigger={
                                            <button
                                                className='flex cursor-pointer items-center space-x-1 rounded-full bg-black px-5 py-1 text-xs text-white'
                                                aria-label='ویدیو راهنما'
                                            >
                                                <VideoCircle width={12} />
                                                <span>ویدیو راهنما</span>
                                            </button>
                                        }
                                    />
                                </div>
                            </div>
                            <StoryProgram
                                hasChatBot={hasChatBot}
                                date={date}
                                onGuide={openGuide}
                                story={story}
                                programID={programID}
                                dayNumber={dayNumber}
                                canPerformTask={canPerformTask}
                            />
                        </>
                    ) : (
                        <>ندارد</>
                    )}
                </CustomCollapse> */}
            </section>

            {/* <ProgramCategory
                title={t('program', t('story'))}
                description={story?.is_done ? 'تکمیل شده' : `شروع از ساعت ${story?.started_at}`}
                status={story?.is_done ? 'done' : 'progress'}
                onClick={sheet.onTrue}
                disabled={!story}
            /> */}
            {/* {story ? (
                <BottomSheet title={`${t('program')} ${t('story')}`} open={sheet.value} onClose={sheet.onFalse}>
                    <StoryProgram
                        hasChatBot={hasChatBot}
                        date={date}
                        onGuide={openGuide}
                        story={story}
                        programID={programID}
                        dayNumber={dayNumber}
                        canPerformTask={canPerformTask}
                    />
                </BottomSheet>
            ) : null} */}
            <GuideDialog open={guide !== undefined} onClose={closeGuide} guide={guide} />
        </>
    );
};

export default StoryTask;

